module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "voucher"
    }
  }, [_vm._v("Voucher")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "voucher",
      "disabled": ""
    },
    model: {
      value: (_vm.voucherNo),
      callback: function($$v) {
        _vm.voucherNo = $$v
      },
      expression: "voucherNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', [_vm._v("Account")]), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredAccounts,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      },
      "change": _vm.nepaliDate
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "drAmount"
    }
  }, [_vm._v("Debit Amount")]), _vm._v(" "), (_vm.txnAmountCr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "min": 0,
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00')\n                              this.value = ''",
      "id": "drAmount",
      "bodyStyle": "text-align: right",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountDr),
      callback: function($$v) {
        _vm.txnAmountDr = $$v
      },
      expression: "txnAmountDr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "crAmount"
    }
  }, [_vm._v("Credit Amount")]), _vm._v(" "), (_vm.txnAmountDr > 0) ? _c('InputNumber', {
    attrs: {
      "id": "crAmount",
      "bodyStyle": "text-align: right",
      "min": 0,
      "minFractionDigits": 2,
      "maxFracionDigits": 4,
      "disabled": ""
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  }) : _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00')\n                              this.value = ''",
      "id": "crAmount",
      "bodyStyle": "text-align: right",
      "min": 0,
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.txnAmountCr),
      callback: function($$v) {
        _vm.txnAmountCr = $$v
      },
      expression: "txnAmountCr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "shortNarr"
    }
  }, [_vm._v("Short Narration")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "shortNarr"
    },
    model: {
      value: (_vm.narration3),
      callback: function($$v) {
        _vm.narration3 = $$v
      },
      expression: "narration3"
    }
  })], 1), _vm._v(" "), (!_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button p-component addNewBtn btn-btm-0",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTransactionToDTO.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDTO),
      expression: "editDTO"
    }],
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetAccountDto.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.account.closingBalance >= 0 || _vm.account.closingBalance < 0) ? _c('label', {
    attrs: {
      "for": "closingBalance"
    }
  }, [_vm._v("Cur. Bal:")]) : _vm._e(), _vm._v(" "), (_vm.account.closingBalance > 0) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s((_vm.account.closingBalance).toFixed(2) + ' ' + 'Cr'))]) : (_vm.account.closingBalance === 0) ? _c('b', [_vm._v("\n                " + _vm._s((_vm.account.closingBalance).toFixed(2)) + "\n              ")]) : (_vm.account.closingBalance < 0) ? _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                  " + _vm._s((_vm.account.closingBalance).toFixed(2) * (-1) + ' ' + 'Dr') + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.account.isBankAccount),
      expression: "account.isBankAccount"
    }],
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cheque Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.chequeDate),
      callback: function($$v) {
        _vm.chequeDate = $$v
      },
      expression: "chequeDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "chequeDate"
    },
    model: {
      value: (_vm.chequeDate),
      callback: function($$v) {
        _vm.chequeDate = $$v
      },
      expression: "chequeDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.account.isBankAccount),
      expression: "account.isBankAccount"
    }],
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "Pdc"
    }
  }, [_vm._v("Cheque No")]), _vm._v(" "), _c('InputText', {
    model: {
      value: (_vm.chequeNumber),
      callback: function($$v) {
        _vm.chequeNumber = $$v
      },
      expression: "chequeNumber"
    }
  })], 1), _vm._v(" "), (_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button p-component addNewBtn btn-btm-0",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTransactionToDTO.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.account.isBankAccount) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDTO),
      expression: "editDTO"
    }],
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetAccountDto.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "jouscroll"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Account Name")]), _vm._v(" "), _c('th', [_vm._v("Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Credit Amount")]), _vm._v(" "), (this.bank) ? _c('th', [_vm._v("Cheque Date")]) : _vm._e(), _vm._v(" "), (this.cheque) ? _c('th', [_vm._v("Cheque Number")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Short Narration")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.transactionDetailDTOList), function(account, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.accountMaster.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(account.drCr == 'D' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(account.drCr == 'C' ? account.txnAmount : '') + " ")]), _vm._v(" "), (_vm.bank) ? _c('td', [_vm._v(_vm._s(account.chequeDate) + " ")]) : _vm._e(), _vm._v(" "), (_vm.cheque) ? _c('td', [_vm._v(_vm._s(account.chequeNumber) + " ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.narration3) + " ")]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editAccountFromDTO(account, index)
        }
      }
    }), _vm._v(" "), (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAccountFromDTO(account, index)
        }
      }
    }) : _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash",
        "disabled": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteAccountFromDTO(account, index)
        }
      }
    })], 1)])])
  })], 2)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "12em",
      "color": "#3c8dbc",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.drtotal.toFixed(4)))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "5em",
      "color": "#3c8dbc",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.crTotal.toFixed(4)))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    staticClass: "_drcr"
  }, [_vm._v("Diff Amt")]), _vm._v(" "), (_vm.calculation === 0) ? _c('span', {
    staticStyle: {
      "margin-left": "2em",
      "color": "green",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.calculation.toFixed(4)))]) : _c('span', {
    staticStyle: {
      "margin-left": "2em",
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.calculation.toFixed(4)))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "narration1"
    }
  }, [_vm._v("Narration")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "narration1",
      "rows": "6"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": !_vm.editing ? 'Save' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveBankTransfer.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (this.bankTransfer != undefined) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [(this.bankTransfer == undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    staticClass: "_drcr",
    staticStyle: {
      "margin-left": "14em"
    }
  }, [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c0f5140"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/banking/banktransfer.vue
// module id = 2340
// module chunks = 0